<template>
	<div id="Perinfor">
		<div class="g-right-top width800">个人中心／编辑资料／基本信息</div>
		<div class="g-right-middle margintop20 width800">
			<div class="info-tit float-left">基本信息</div>
			<div class="el-icon-edit float-right" @click="centerDialogVisible1 = true" v-if="this.uid==null?true:false">新增</div>
			<el-dialog title="基本信息" :close-on-click-modal='false' :visible.sync="centerDialogVisible1" width="30%" center>
				<M_Jbxx_add></M_Jbxx_add>
			</el-dialog>
			<div class="el-icon-edit float-right" @click="centerDialogVisible = true" v-if="this.uid!==null?true:false">修改</div>
			<el-dialog title="基本信息" :close-on-click-modal='false' :visible.sync="centerDialogVisible" width="30%" center>
				<M_Jbxx></M_Jbxx>
			</el-dialog>
			<div class="clearfix"></div>
			<div class="g-base">
				<div class="float-left p-left">
					<img src="../../assets/mrimg.png" width="260" height="360" v-if="list.picture==='' ? true:false" style="border: 1px solid #eee; box-sizing: border-box;">
					<img :src="list.picture" width="260" height="360" v-if="list.picture!=='' ? true:false">
				</div>
				<div class="float-right p-right">
					<h2>{{list.name}}</h2>

					<div class="p-detail">{{list.detailed}}</div>
				</div>
				<div class="clearfix"></div>

				<div class="p-base-p float-left" style="margin-top: 30px;">
					<p>中文名：{{list.name}}</p>
					<p>性别：{{list.sex}}</p>
					<p>身高：{{list.stature}}cm</p>
					<p v-if="list.bwh==='' ? false:true">三围：{{list.bwh}}</p>
					<p v-if="list.constellation==='' ? false:true">星座：{{list.constellation}}</p>
					<p>出生日期：{{list.bom_time}}</p>
					<p>联系方式：{{list.agent_contact}}</p>
					<p>微信号：{{list.wechat}}</p>
					<p>职业：{{list.vocation}}</p>
					<p>特长：<span v-for="item in list.perf_keyword" v-if="item.state===1" :key="item.id">{{item.tag}}&nbsp;|&nbsp;</span></p>
					<p>座右铭：{{list.signature}}</p>
				</div>
				<div class="p-base-p float-left" style="margin-top: 30px;">
					<p>英文名：{{list.english_name}}</p>
					<p>民族：{{list.nation}}</p>
					<p>体重：{{list.weight}}kg</p>
					<p v-if="list.blood==='' ? false:true">血型：{{list.blood}}型</p>
					<p v-if="list.place==='' ? false:true">出生地：{{list.place}}</p>
					<p v-if="list.school==='' ? false:true">毕业院校：{{list.school}}</p>
					<p>经纪公司：{{list.manage}}</p>
					<p>qq号：{{list.qq_number}}</p>
					<p>脸型：{{list.feature}}</p>
					<p>标签：<span v-for="item in list.perf_keyword" v-if="item.state===2" :key="item.id">{{item.tag}}&nbsp;|&nbsp;</span></p>
				</div>
				<div class="clearfix"></div>
			</div>
			<!-- 电影作品 -->
			<div class="info-tit float-left" style="margin-bottom: 40px;">电影作品</div>
			<div class="float-right el-icon-edit " @click="centerDialogVisible2 = true" v-if="list.film_works!=='' ? true:false">修改</div>
			<div class="clearfix"></div>
			<div class="new-textarea" @click="centerDialogVisible2 = true" v-if="list.film_works==='' ? true:false">请填写相关信息</div>
			<el-dialog title="作品简介" :close-on-click-modal='false' :visible.sync="centerDialogVisible2" width="33.5%">
				<M_Film></M_Film>
			</el-dialog>
			<div class="time" v-if="list.film_works!=='' ? true:false" v-html="list.film_works">
				<!-- {{list.film_works}} -->
			</div>
			<div class="actor-pics">

				<img v-for="(item,key) in list.perf_works_picture" :key='key' :src="item.image_url" v-if="item.number===1" width="180"
				 height="252" @click="del_film_pic(key,item.id)">


				<div class="add_more_pic el-icon-plus" @click="centerDialogVisible3 = true"></div>

				<div class="clearfix"></div>
			</div>

			<el-dialog title="作品照片" :close-on-click-modal='false' :visible.sync="centerDialogVisible3" width="33.5%">
				<M_Filmpic></M_Filmpic>
			</el-dialog>
			<!-- 电视剧作品 -->
			<div class="info-tit float-left" style="margin-bottom: 40px;">电视剧作品</div>
			<div class="float-right el-icon-edit " @click="centerDialogVisible6 = true" v-if="list.tv_works!=='' ? true:false">修改</div>
			<div class="clearfix"></div>
			<div class="new-textarea" @click="centerDialogVisible6 = true" v-if="list.tv_works==='' ? true:false">请填写相关信息</div>
			<el-dialog title="作品简介" :close-on-click-modal='false' :visible.sync="centerDialogVisible6" width="33.5%">
				<M_Tv></M_Tv>
			</el-dialog>
			<div class="time" v-if="list.tv_works!=='' ? true:false" v-html="list.tv_works">
			</div>
			<div class="actor-pics">

				<img v-for="(item,key) in list.perf_works_picture" :key='key' :src="item.image_url" v-if="item.number===2" width="180"
				 height="252" @click="del_tv_pic(key,item.id)">

				<div class="add_more_pic el-icon-plus" @click="centerDialogVisible7 = true"></div>

				<div class="clearfix"></div>
			</div>

			<el-dialog title="作品照片" :close-on-click-modal='false' :visible.sync="centerDialogVisible7" width="33.5%">
				<M_Tvpic></M_Tvpic>
			</el-dialog>
			<!-- 广告作品 -->
			<div class="info-tit float-left" style="margin-bottom: 40px;">广告作品</div>
			<div class="float-right el-icon-edit " @click="centerDialogVisible8 = true" v-if="list.advertising_works!=='' ? true:false">修改</div>
			<div class="clearfix"></div>
			<div class="new-textarea" @click="centerDialogVisible8 = true" v-if="list.advertising_works==='' ? true:false">请填写相关信息</div>
			<el-dialog title="作品简介" :close-on-click-modal='false' :visible.sync="centerDialogVisible8" width="33.5%">
				<M_Adv></M_Adv>
			</el-dialog>
			<div class="time" v-if="list.advertising_works!=='' ? true:false" v-html="list.advertising_works">
			</div>
			<div class="actor-pics">

				<img v-for="(item,key) in list.perf_works_picture" :key='key' :src="item.image_url" v-if="item.number===3" width="180"
				 height="252" @click="del_adv_pic(key,item.id)">

				<div class="add_more_pic el-icon-plus" @click="centerDialogVisible9 = true"></div>

				<div class="clearfix"></div>
			</div>

			<el-dialog title="作品照片" :close-on-click-modal='false' :visible.sync="centerDialogVisible9" width="33.5%">
				<M_Advpic></M_Advpic>
			</el-dialog>
			<div class="info-tit " style="margin-top: 40px;">我的写真</div>
			<div class="actor-pics">
				<ul>
					<li v-for="(item,key) in list.perf_picture" :key='key'><img :src="item.image_url" width="180" height="252" @click="del_wdxz(key,item.id)"></li>
					<li>
						<div class="add_more_pic el-icon-plus" @click="centerDialogVisible4 = true"></div>
					</li>
				</ul>
				<div class="clearfix"></div>
			</div>

			<el-dialog title="我的写真" :close-on-click-modal='false' :visible.sync="centerDialogVisible4" width="33.5%">
				<M_Wdxz></M_Wdxz>
			</el-dialog>
			<div class="info-tit float-left">我的Casting</div>
			<div class="float-right el-icon-edit " @click="centerDialogVisible5 = true">修改</div>
			<el-dialog title="我的视频" :close-on-click-modal='false' :visible.sync="centerDialogVisible5" width="30%" center>
				<M_Wdsp></M_Wdsp>
			</el-dialog>
			<div class="clearfix"></div>
			<div class="g-base">
				<center>
					<video width="600" height="350" :src="list.video" controls>
						您的浏览器不支持 video 标签。
					</video>
				</center>
			</div>
		</div>

	</div>
</template>

<script>
	import storage from '../../storage/storage.js'
	import M_Jbxx from '@/components/per_admin/per_modify/M_Jbxx.vue'
	import M_Jbxx_add from '@/components/per_admin/per_modify/M_Jbxx_add.vue'
	import M_Wdsp from '@/components/per_admin/per_modify/M_Wdsp.vue'
	import M_Wdxz from '@/components/per_admin/per_modify/M_Wdxz.vue'
	import M_Film from '@/components/per_admin/per_modify/M_Film.vue'
	import M_Tv from '@/components/per_admin/per_modify/M_Tv.vue'
	import M_Adv from '@/components/per_admin/per_modify/M_Adv.vue'
	import M_Filmpic from '@/components/per_admin/per_modify/M_Filmpic.vue'
	import M_Tvpic from '@/components/per_admin/per_modify/M_Tvpic.vue'
	import M_Advpic from '@/components/per_admin/per_modify/M_Advpic.vue'
	import Axios from 'axios'
	export default {
		data() {
			return {
				Re: true,
				list: '', //渲染数据定义的list
				uid: storage.get('userdata'), //用户身份的uid
				centerDialogVisible: false, //基本信息修改的状态属性
				centerDialogVisible1: false,
				centerDialogVisible2: false, //电影描述
				centerDialogVisible3: false, //电影照片
				centerDialogVisible4: false, //我的写真修改状态属性
				centerDialogVisible5: false, //我的视频修改状态属性
				centerDialogVisible6: false, //电视剧描述
				centerDialogVisible7: false, //电视剧照片
				centerDialogVisible8: false, //广告描述
				centerDialogVisible9: false, //广告照片
				delpic: false,
				last_time: '', //时间
				synopsis: '', //简介
				picture: [], //图片
				m_yyjl_id: '', //条数所属id
				pic_num: '', //我的写真图片指定id
				pic_id: '' //我的写真图片后台id
			};
		},
		components: {
			M_Jbxx,
			M_Jbxx_add,
			M_Wdsp,
			M_Wdxz,
			M_Film,
			M_Tv,
			M_Adv,
			M_Filmpic,
			M_Tvpic,
			M_Advpic,
		},
		methods: {
			del_film_pic(key, id) { //删除电影图片

				this.$Modal.confirm({
					title: '警告！',
					content: '确认删除？',
					onOk: () => {
						// this.$Message.info('点击了确定');
						var api = 'http://api.yopoo.cn/api/centre/deleteworks?pictureId=' + id //修改单张图片接口
						var token = storage.get('token')
						Axios.get(api, {
							headers: {
								'Authorization': token
							}
						}).then((res) => {
							if (res.data.code == 200) { //判断返回状态码
								this.$message({
									message: res.data.msg, //获取返回状态信息
									type: 'success',
									center: true
								});
								this.list.perf_works_picture.splice(key, 1) //删除当前下标数据
								this.list.perf_works_picture.splice(id, 1) //删除真实id数据
							}
							if (res.data.code == 202) { //判断返回状态码
								this.$message({
									message: res.data.msg, //获取返回状态信息
									type: 'error',
									center: true
								});
							}
						})
					},
					onCancel: () => {
						// this.$Message.info('点击了取消');
					}
				});



			},
			del_tv_pic(key, id) { //删除电视剧图片
				this.$Modal.confirm({
					title: '警告！',
					content: '确认删除？',
					onOk: () => {
						var api = 'http://api.yopoo.cn/api/centre/deleteworks?pictureId=' + id //修改单张图片接口
						var token = storage.get('token')
						Axios.get(api, {
							headers: {
								'Authorization': token
							}
						}).then((res) => {
							if (res.data.code == 200) { //判断返回状态码
								this.$message({
									message: res.data.msg, //获取返回状态信息
									type: 'success',
									center: true
								});
								this.list.perf_works_picture.splice(key, 1) //删除当前下标数据
								this.list.perf_works_picture.splice(id, 1) //删除真实id数据
							}
							if (res.data.code == 202) { //判断返回状态码
								this.$message({
									message: res.data.msg, //获取返回状态信息
									type: 'error',
									center: true
								});
							}
						})

					},
					onCancel: () => {
						// this.$Message.info('点击了取消');
					}
				});


			},
			del_adv_pic(key, id) { //删除广告图片
				this.$Modal.confirm({
					title: '警告！',
					content: '确认删除？',
					onOk: () => {
						var api = 'http://api.yopoo.cn/api/centre/deleteworks?pictureId=' + id //修改单张图片接口
						var token = storage.get('token')
						Axios.get(api, {
							headers: {
								'Authorization': token
							}
						}).then((res) => {
							if (res.data.code == 200) { //判断返回状态码
								this.$message({
									message: res.data.msg, //获取返回状态信息
									type: 'success',
									center: true
								});
								this.list.perf_works_picture.splice(key, 1) //删除当前下标数据
								this.list.perf_works_picture.splice(id, 1) //删除真实id数据
							}
							if (res.data.code == 202) { //判断返回状态码
								this.$message({
									message: res.data.msg, //获取返回状态信息
									type: 'error',
									center: true
								});
							}
						})
					},
					onCancel: () => {
						// this.$Message.info('点击了取消');
					}
				});


			},
			del_wdxz(key, id) { //删除艺人展示图片
				this.$Modal.confirm({
					title: '警告！',
					content: '确认删除？',
					onOk: () => {

						var api = 'http://api.yopoo.cn/api/centre/deletecast?id=' + id //修改单张图片接口
						var token = storage.get('token')
						Axios.get(api, {
							headers: {
								'Authorization': token
							}
						}).then((res) => {
							if (res.data.code == 200) { //判断返回状态码
								this.$message({
									message: res.data.msg, //获取返回状态信息
									type: 'success',
									center: true
								});
								this.list.perf_picture.splice(key, 1) //删除当前下标数据
								this.list.perf_picture.splice(id, 1) //删除真实id数据
							}
							if (res.data.code == 202) { //判断返回状态码
								this.$message({
									message: res.data.msg, //获取返回状态信息
									type: 'error',
									center: true
								});
							}
						})
					},
					onCancel: () => {
						// this.$Message.info('点击了取消');
					}
				});
			},


			requestData() { //渲染页面详细信息
				var api = 'http://api.yopoo.cn/api/centre/forartists?id=' + this.uid;
				let token = storage.get('token')
				Axios.get(api, {
					headers: {
						'Authorization': token
					}
				}).then((res) => {
					this.list = res.data;
					storage.set('name', res.data.name) //姓名
					storage.set('english_name', res.data.english_name) //英文名
					storage.set('stature', res.data.stature) //
					storage.set('weight', res.data.weight) //体重
					storage.set('bwh', res.data.bwh) //三围
					storage.set('place', res.data.place) //出生地
					storage.set('bom_time', res.data.bom_time) //出生日期
					storage.set('school', res.data.school) //毕业院校
					storage.set('vocation', res.data.vocation) //职业
					storage.set('perf_keyword', res.data.perf_keyword) //
					storage.set('detailed', res.data.detailed) //简介
					storage.set('signature', res.data.signature) //
					storage.set('imgsrc', res.data.picture) //个人图片链接
					storage.set('timer', res.data.timer)
					storage.set('agent_contact', res.data.agent_contact)
					storage.set('qq_number', res.data.qq_number)
					storage.set('manage', res.data.manage)
					storage.set('wechat', res.data.wechat)
					storage.set('film_works', res.data.film_works)
					storage.set('tv_works', res.data.tv_works)
					storage.set('advertising_works', res.data.advertising_works)
					//------------------性别信息判断------------------//
					var s = res.data.sex //定义获取的性别信息
					if (s == '男') {
						storage.set('sex', '1') //判断性别为男，则存储值为1
					}
					if (s == '女') {
						storage.set('sex', '2') //判断性别为女，则存储值为2
					}
					if (s == '保密') {
						storage.set('sex', '3') //判断性别为保密，则存储值为3
					}
					//------------------血型信息判断------------------//
					var b = res.data.blood //定义获取的血型信息
					if (b == 'A') {
						storage.set('blood', '1') //判断血型为A，则存储值为1
					}
					if (b == 'B') {
						storage.set('blood', '2') //判断血型为B，则存储值为2
					}
					if (b == 'AB') {
						storage.set('blood', '3') //判断血型为AB，则存储值为3
					}
					if (b == 'O') {
						storage.set('blood', '4') //判断血型为O，则存储值为4
					}
					if (b == '') {
						storage.set('blood', '') //判断血型为空，则存储值为空
					}
					//-------------------星座信息判断-----------------//
					var c = res.data.constellation //定义获取星座信息
					if (c == '白羊座') {
						storage.set('constellation', '1') //星座
					}
					if (c == '金牛座') {
						storage.set('constellation', '2') //星座
					}
					if (c == '双子座') {
						storage.set('constellation', '3') //星座
					}
					if (c == '巨蟹座') {
						storage.set('constellation', '4') //星座
					}
					if (c == '狮子座') {
						storage.set('constellation', '5') //星座
					}
					if (c == '处女座') {
						storage.set('constellation', '6') //星座
					}
					if (c == '天秤座') {
						storage.set('constellation', '7') //星座
					}
					if (c == '天蝎座') {
						storage.set('constellation', '8') //星座
					}
					if (c == '射手座') {
						storage.set('constellation', '9') //星座
					}
					if (c == '摩羯座') {
						storage.set('constellation', '10') //星座
					}
					if (c == '水瓶座') {
						storage.set('constellation', '11') //星座
					}
					if (c == '双鱼座') {
						storage.set('constellation', '12') //星座
					}
					if (c == '') {
						storage.set('constellation', '') //星座
					}
					//-------------------脸型信息判断-----------------//
					var f = res.data.feature //定义获取的脸型信息
					if (f == '鹅蛋脸') {
						storage.set('feature', '1') //脸型
					}
					if (f == '菱形脸') {
						storage.set('feature', '2') //脸型
					}
					if (f == '国字脸') {
						storage.set('feature', '3') //脸型
					}
					if (f == '瓜子脸') {
						storage.set('feature', '4') //脸型
					}
					if (f == '圆形脸') {
						storage.set('feature', '5') //脸型
					}
					if (f == '方型脸') {
						storage.set('feature', '6') //脸型
					}
					if (f == '三角脸') {
						storage.set('feature', '7') //脸型
					}
					if (f == '') {
						storage.set('feature', '') //脸型
					}
					//------------------职业信息判断------------------//
					var v = res.data.vocation //定义获取职业信息
					if (v == '演员') {
						storage.set('vocation', '1') //职业
					}
					if (v == '模特') {
						storage.set('vocation', '2') //职业
					}
					if (v == '歌手') {
						storage.set('vocation', '3') //职业
					}
					if (v == '导演') {
						storage.set('vocation', '4') //职业
					}
					if (v == '副导演') {
						storage.set('vocation', '5') //职业
					}
					if (v == '编剧') {
						storage.set('vocation', '6') //职业
					}
					if (v == '制片') {
						storage.set('vocation', '7') //职业
					}
					if (v == '主持人') {
						storage.set('vocation', '8') //职业
					}

					//------------------民族判断------------------//
					var n = res.data.nation
					if (n == '汉族') {
						storage.set('nation', '1') //民族
					}
					if (n == '满族') {
						storage.set('nation', '2') //民族
					}
					if (n == '壮族') {
						storage.set('nation', '3') //民族
					}
					if (n == '回族') {
						storage.set('nation', '4') //民族
					}
					if (n == '苗族') {
						storage.set('nation', '5') //民族
					}
					if (n == '维吾尔族') {
						storage.set('nation', '6') //民族
					}
					if (n == '土家族') {
						storage.set('nation', '7') //民族
					}
					if (n == '彝族') {
						storage.set('nation', '8') //民族
					}
					if (n == '蒙古族') {
						storage.set('nation', '9') //民族
					}
					if (n == '藏族') {
						storage.set('nation', '10') //民族
					}
					if (n == '布依族') {
						storage.set('nation', '11') //民族
					}
					if (n == '侗族') {
						storage.set('nation', '12') //民族
					}
					if (n == '瑶族') {
						storage.set('nation', '13') //民族
					}
					if (n == '朝鲜族') {
						storage.set('nation', '14') //民族
					}
					if (n == '白族') {
						storage.set('nation', '15') //民族
					}
					if (n == '哈尼族') {
						storage.set('nation', '16') //民族
					}
					if (n == '哈萨克族') {
						storage.set('nation', '17') //民族
					}
					if (n == '黎族') {
						storage.set('nation', '18') //民族
					}
					if (n == '傣族') {
						storage.set('nation', '19') //民族
					}
					if (n == '畲族') {
						storage.set('nation', '20') //民族
					}
					if (n == '傈傈族') {
						storage.set('nation', '21') //民族
					}
					if (n == '仡佬族') {
						storage.set('nation', '22') //民族
					}
					if (n == '东乡族') {
						storage.set('nation', '23') //民族
					}
					if (n == '高山族') {
						storage.set('nation', '24') //民族
					}
					if (n == '拉祜族') {
						storage.set('nation', '25') //民族
					}
					if (n == '水族') {
						storage.set('nation', '26') //民族
					}
					if (n == '佤族') {
						storage.set('nation', '27') //民族
					}
					if (n == '纳西族') {
						storage.set('nation', '28') //民族
					}
					if (n == '羌族') {
						storage.set('nation', '29') //民族
					}
					if (n == '土族') {
						storage.set('nation', '30') //民族
					}
					if (n == '仫佬族') {
						storage.set('nation', '31') //民族
					}
					if (n == '锡伯族') {
						storage.set('nation', '32') //民族
					}
					if (n == '柯尔克孜族') {
						storage.set('nation', '33') //民族
					}
					if (n == '达斡尔族') {
						storage.set('nation', '34') //民族
					}
					if (n == '景颇族') {
						storage.set('nation', '35') //民族
					}
					if (n == '毛南族') {
						storage.set('nation', '36') //民族
					}
					if (n == '撒拉族') {
						storage.set('nation', '37') //民族
					}
					if (n == '塔吉克族') {
						storage.set('nation', '38') //民族
					}
					if (n == '阿昌族') {
						storage.set('nation', '39') //民族
					}
					if (n == '普米族') {
						storage.set('nation', '40') //民族
					}
					if (n == '鄂温克族') {
						storage.set('nation', '41') //民族
					}
					if (n == '怒族') {
						storage.set('nation', '42') //民族
					}
					if (n == '京族') {
						storage.set('nation', '43') //民族
					}
					if (n == '基诺族') {
						storage.set('nation', '44') //民族
					}
					if (n == '德昂族') {
						storage.set('nation', '45') //民族
					}
					if (n == '保安族') {
						storage.set('nation', '46') //民族
					}
					if (n == '俄罗斯族') {
						storage.set('nation', '47') //民族
					}
					if (n == '裕固族') {
						storage.set('nation', '48') //民族
					}
					if (n == '乌兹别克族') {
						storage.set('nation', '49') //民族
					}
					if (n == '门巴族') {
						storage.set('nation', '50') //民族
					}
					if (n == '鄂伦春族') {
						storage.set('nation', '51') //民族
					}
					if (n == '独龙族') {
						storage.set('nation', '52') //民族
					}
					if (n == '塔塔尔族') {
						storage.set('nation', '53') //民族
					}
					if (n == '赫哲族') {
						storage.set('nation', '54') //民族
					}
					if (n == '珞巴族') {
						storage.set('nation', '55') //民族
					}
					if (n == '布朗族') {
						storage.set('nation', '56') //民族
					}

					//------------------标签及特长信息判断------------------//
					var t = res.data.perf_keyword //定义获取到的perf_keyword值
					var m_tag = [] //定义空数组用以存储tag值
					var m_label = [] //定义空数组用以存储tag值
					for (var i = 0; i < t.length; i++) {
						if (t[i].state == 1) { //判断state的情况
							m_tag.unshift(t[i].id) //将state=1的值插入之前定义的数组内
						}
						if (t[i].state == 2) { //判断state=1的情况
							m_label.unshift(t[i].id) //将state=2的值插入之前定义的数组内
						}
					}
					storage.set('m_tag', m_tag) //将循环出来的tag特长存储
					storage.set('m_label', m_label) //将循环出来的label标签存储

					//-----------------判断图片为空渲染页面隐藏效果-------------------//
					// 					if (res.data.perf_picture == '') { //没有数据的时候将默认图片信息隐藏起来
					// 						$('.actor-show2').hide()
					// 						storage.del('add_newpic')
					// 					}
					// 					if (res.data.perf_picture != '') {
					// 						$('.new_add').css('display', 'none') //默认判断我的写真是否有数据，有则隐藏增加按钮，没有则显示增加按钮
					// 					}
				}, (err) => {
					console.log(err)
				})
			},
		},
		mounted() {
			this.requestData()
			if (storage.get('add_newpic') == '1') {
				$('.new_add').css('display', 'none') //默认判断我的写真是否有数据，有则隐藏增加按钮，没有则显示增加按钮
			}
			if (storage.get('add_newpic')) {
				$('.new_add').css('display', 'block') //默认判断我的写真是否有数据，有则隐藏增加按钮，没有则显示增加按钮
			}
		},
	}
</script>
<style>
	.delpic {
		width: 400px !important;
	}

	.actor-show2 ul li {
		width: 185px;
		float: left;
		/* height: 550px; */
		list-style-type: none;
	}


	.add_more_pic {
		width: 180px;
		height: 252px;
		border: 1px dashed #999;
		text-align: center;
		line-height: 252px;
		font-size: 50px;
		color: #999;
		box-sizing: border-box;
		margin: 0 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/per_admin/P_Perinfor.vue